import { getDateNum } from 'utils/querySimulation';

const planetNames = {
	mushroomKingdom: 'Mushroom Kingdom',
	honeyhiveGalaxy: 'Honeyhive Galaxy',
	fossilFalls: 'Fossil Falls',
	cometObservatory: 'Comet Observatory',
	tostarenaTown: 'Tostarena Town',
	dripDropGalaxy: 'Drip Drop Galaxy',
	spaceJunkGalaxy: 'Space Junk Galaxy'
};

export default {
	$title: 'Gateway Galaxy',
	$mushroomKingdom: planetNames.mushroomKingdom,
	$honeyhiveGalaxy: planetNames.honeyhiveGalaxy,
	$fossilFalls: planetNames.fossilFalls,
	$cometObservatory: planetNames.cometObservatory,
	$tostarenaTown: planetNames.tostarenaTown,
	$dripDropGalaxy: planetNames.dripDropGalaxy,
	$spaceJunkGalaxy: planetNames.spaceJunkGalaxy,
	$intro: {
		clickStar: 'Click star',
		toEnter: 'to enter',
	},
	$boardingTimes: {
		title: 'Boarding Times',
		subtitle: 'Current departures from the Gateway Galaxy.',
		boardingNow: 'Boarding Now',
		noFlightZone: 'All flights cancelled',
		delayed: 'Delayed',
		altText: 'Gateway Galaxy boarding times page displaying available and upcoming travel destinations.'
	},
	$travelerNotices: {
		title: 'Traveler Notices',
		missingAlert: '**Have you seen this princess?** Rosalina was last seen at the Comet Observatory. Visitors with any information are asked to report it to Gateway Galaxy personnel immediately.',
		starfox: "Looking for a pilot? Fox McCloud was recently spotted on our flight deck. He'll take you anywhere you want to go, for the right price.",
		starfoxButton: 'Discover more', //TRAVELER NOTICE EASTER EGG UPDATE
		starfoxEasterEggHeading: 'Fox McCloud', //TRAVELER NOTICE EASTER EGG UPDATE
		ukikiWarning: '**Theft advisory.** <br/> Visitors are advised to secure all personal belongings and remain aware of their surroundings.',
		altText: 'Official notices and advisories for visitors to the Gateway Galaxy. Please review all postings before continuing your journey.'
	},
	$lostAndFound: {
		title: 'Lost & Found',
		subtitle: 'Items recovered by Gateway Galaxy Security are logged here for review and retrieval.',
		items: {
			pineappleLuggage: { name: 'Pineapple Rolling Case', description: 'Hard-shell rolling luggage with a bright, tropical exterior.' },
			hardShellSuitcase: { name: 'Hard-Shell Suitcase', description: 'Contains one wooden hammer with Mole claw marks on the handle.' },
			iglooBackpack: { name: 'Igloo Backpack', description: 'Commonly used to keep supplies from thawing during transit.' },
			superMushroom: { name: 'Super Mushroom', description: 'Size fluctuations may occur.' },
			greenTurtleShell: { name: 'Green Turtle Shell', description: 'Recovered without Koopa. Owner likely nearby and moderately embarrassed' },
			toadsNovel: { name: 'Unfinished Novel', description: 'A partially completed manuscript recovered from a seating area.' },
		},
		altText: 'Lost and Found page cataloging unclaimed items recovered within the Gateway Galaxy.'
	},
	$stayConnected: {
		title: 'Stay Connected',
		subtitle: '**There\'s a huge universe out there, with a lot of galaxies.** Stay in the know with updates from R.O.B.',
		// description: 'Text 929-556-2746 to receive updates from Gateway Galaxy during your visit.',
		socials: [
			{ id: 'insta', name: 'Instagram', link: 'https://www.instagram.com/supermariomovie' },
			{ id: 'x', name: 'X', link: 'https://x.com/supermariomovie' },
			{ id: 'tiktok', name: 'TikTok', link: 'https://www.tiktok.com/@supermariomovie' }
		],
		altText: 'Stay Connected page prompting visitors to receive official Gateway Galaxy updates and notifications.'
	},
	$watchAtHome: {
		title: 'Watch at home',
		merchants: [
			{ id: 'fandango', name: 'Fandango At Home', link: 'https://athome.fandango.com/content/browse/details/The-Super-Mario-Galaxy-Movie/4935551' },
			{ id: 'prime', name: 'Prime Video', link: 'https://www.amazon.com/gp/video/detail/B0GRL9HMKK' },
			{ id: 'xfinity', name: 'Xfinity', link: 'https://www.xfinity.com/stream/entity/8475640512331779112' },
			{ id: 'apple', name: 'Apple TV', link: 'https://tv.apple.com/us/movie/the-super-mario-galaxy-movie/umc.cmc.48lrb0v87osrqj3679ifs8py6' },
			{ id: 'youtube', name: 'YouTube', link: 'https://www.youtube.com/watch?v=9ny0kISvD6g' },
			{ id: 'verizon', name: 'Verizon', link: 'https://tv.verizon.com/watch/movie/The-Super-Mario-Galaxy-Movie/MV026908590000?idType=TMS&qualifiedId=TMS-MV026908590000' },
			{ id: 'amazon', name: 'Amazon', link: 'https://www.amazon.com/Super-Mario-Galaxy-Blu-ray-Digital/dp/B0GQTDPJ36' },
			{ id: 'walmart', name: 'Walmart', link: 'https://www.walmart.com/ip/The-Super-Mario-Galaxy-Movie-Blu-Ray-Digital-Copy-Universal-Animated-Family/20019706996' },
			{ id: 'gruv', name: 'Gruv', link: 'https://gruv.com/collections/the-super-mario-bros-movie?_pos=1&_psq=super+ma&_ss=e&_v=1.0' },
		],
	},
	$passport: {
		title: 'Galactic Collectable',
		routePassportTitle: 'Galactic Passport',
		routeSouvenirTitle: 'Galactic Souvenir',
		intro: '**Watching in theaters or at home?** Get your exclusive Super Mario Galaxy Movie digital collectables for your Apple or Google Wallet.',
		routePassportBtn: 'Passport',
		routeHomeEntBtn: 'Souvenir',
		routePassportBlurb: 'Claim your Galactic Passport',
		routeHomeEntBlurb: 'Get the movie through [ Fandango at Home ](https://athome.fandango.com/content/browse/details/The-Super-Mario-Galaxy-Movie/4935551) to claim your Galactic Souvenir.',
		theatreIntro: '**Have you secured your Galactic Passport?** Find the confirmation code from your ticket purchase.',
		newPassBtn: 'Register New Passport',
		newPassDescription: 'Create your Galactic Passport using the confirmation code from your Fandango ticket purchase.',
		existingTravelerBtn: 'Existing Traveler?',
		existingTravelerDescription: 'Add a new trip to your Galactic Passport using your unique identification number.',
		codeInputNew: 'Enter the confirmation code provided with your Fandango ticket purchase.',
		codeInputExisting: 'Enter the confirmation code provided with your Fandango ticket purchase to add a new badge.',
		passIdInput: 'Enter your unique identification number to access your Galactic Passport.',
		helpTextNew: 'Don\'t have your confirmation code? Complete your ticket purchase through Fandango to receive one and activate your Galactic Passport. See the movie more than once to earn more badges!',
		helpTextExisting: 'Don\'t have a confirmation code? Complete a new ticket purchase via Fandango to add another badge to your Galactic Passport.',
		buyTicketCTA: 'Secure Passage',
		buyTicketLink: 'https://thesupermariogalaxymovie.com',
		scanQRTitle: 'Your Galactic Passport',
		scanQRTitleHomeEnt: 'Your collector’s card',
		scanQR: 'Scan the QR code to add your Galactic Passport to your mobile wallet.',
		addToWallet: 'Use the button below to add your Galactic Passport directly to your wallet.',
		badgeAddedExisting: '**Passport updated successfully!** Check your passport for your new badge.',
		badgeAddedMaximum: '**Passport updated successfully!** You have unlocked all badges for this passport! Check your passport for your new badge.',
		platformChoiceCTA: 'Choose your mobile wallet to store your Galactic Passport.',
		apple: 'Apple Wallet',
		google: 'Google Wallet',
		codeError: 'Code not valid. Please try again.',
		passIdError: 'Passport ID not valid. Please try again.',
		maxRedemptionError: 'You have already unlocked all the badges available for this passport!',
		restart: 'Restart',
		linkCopied: 'Download link copied! Please paste the link in Safari to download your passport.',
		// Home Ent
		introHomeEnt: '**Watching in theaters or at home?** Get your exclusive Super Mario Galaxy Movie digital collectables for your Apple or Google Wallet.',
		codeInputHomeEnt: 'Enter your promo code from Fandango At Home to claim your Galactic Souvenir',
		platformChoiceCTAHomeEnt: 'Choose your mobile wallet to store your Galactic Souvenir.',
		scanQRHomeEnt: 'Scan the QR code to add your Galactic Souvenir to your mobile wallet.',
		addToWalletHomeEnt: 'Use the button below to add your Galactic Souvenir directly to your wallet.',
	},
	$showtimes: {
		title: 'Watch in theaters',
	},
	$planetOverlays: {
		mushroomKingdom: {
			title: planetNames.mushroomKingdom,
			description: 'A popular region known for its open landscapes, distinctive architecture, and interconnected communities.',
			conditions: 'Clear and temperate conditions. Light breezes with high visibility throughout most areas.',
			seasonalOutlook: 'Stable conditions expected across cycles. Increased activity during daylight hours.',
			notice: 'Due to unforseen circumstances, castle visitations will be unavailable until further notice.'
		},
		honeyhiveGalaxy: {
			title: planetNames.honeyhiveGalaxy,
			description: 'A vibrant, elevated environment built among towering flowers and natural structures. Honeyhive Galaxy is known for its layered terrain and thriving ecosystem.',
			conditions: 'Warm and bright with steady sunlight. High pollen levels throughout most areas.',
			seasonalOutlook: 'Conditions remain favorable across cycles. Increased activity expected during peak bloom periods.',
			notice: 'Keep off flowers.'
		},
		fossilFalls: {
			title: planetNames.fossilFalls,
			description: 'A rugged landscape defined by steep cliffs, flowing water, and remnants of an ancient past. Fossil Falls is known for its dramatic terrain and abundant natural activity.',
			conditions: 'Warm and clear. Occasional mist near waterfalls and cliff edges.',
			seasonalOutlook: 'Conditions remain stable throughout most cycles. Increased wildlife movement expected during peak daylight hours.',
			notice: 'Remain alert and avoid approaching large creatures. Travel beyond marked paths is not advised.'
		},
		cometObservatory: {
			title: planetNames.cometObservatory,
			description: 'A floating observation facility positioned for celestial monitoring. The Comet Observatory is the home of Princess Rosalina and her Lumas. It is also a star ship that can travel between galaxies.',
			conditions: 'Stable orbital conditions with low gravity. Minimal atmospheric interference.',
			seasonalOutlook: 'Clear visibility expected for the foreseeable cycle. Minor fluctuations may occur during comet activity.',
			notice: 'Megaleg recently sighted in the area. Be alert.'
		},
		tostarenaTown: {
			title: planetNames.tostarenaTown,
			description: 'A desert settlement built among ancient stone structures and sun-warmed plazas. Travelers often pass through on their way across the surrounding sands.',
			conditions: 'Dry heat during daylight hours. Rapid temperature drops after sunset.',
			seasonalOutlook: 'Clear skies and strong sun exposure expected. Limited shade beyond town borders.',
			notice: 'Local festivities may impact standard transit routes.'
		},
		conditions: 'Current conditions',
		seasonalOutlook: 'Seasonal outlook',
		notice: 'Notice',
		mobile: 'Mobile',
		desktop: 'Desktop',
		wallpapers: 'Wallpapers'
	},
	$glyphs: {
		clown: 'Clown',
		peaches: 'Peaches',
		butterfly: 'Butterfly',
		mustache: 'Mustache',
		bones: 'Bones',
		bowser: 'Bowser',
		barrelRoll: 'Barrel Roll'
	},
	$showtimesLink: 'https://thesupermariogalaxymovie.com',
	$upWorld: {
		easterEggHeading: 'Something is hidden among the stars.',
	},
	$downWorld: {
		easterEggHeading: 'Super Bell',
	},
	$ROB: {
		homepage: {
			0: {
				question: 'Welcome to the Gateway Galaxy. I am R.O.B. How may I assist you?',
				response: {
					0: 'View Destinations'
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you.',
				response: {
					0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id:'fossilFalls', label: planetNames.fossilFalls },
					3: { id:'cometObservatory', label: planetNames.cometObservatory },
					4: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					5: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					6: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		boardingTimes: {
			0: {
				question: 'Departure information is updated regularly.',
			},
			1: {
				question: 'This route is not yet open.',
			}
		},
		travelerNotices: {
			0: {
				question: 'Please review all current notices.',
				response: {
					0: "I'm ready to travel."
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you. ',
				response: {
					0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id:'fossilFalls', label: planetNames.fossilFalls },
					3: { id:'cometObservatory', label: planetNames.cometObservatory },
					4: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					5: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					6: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		stayConnected: {
			0: {
				question: 'This channel allows me to reach you wherever you are.',
				response: {
					0: 'Understood'
				}
			}
		},
		lostAndFound: {
			0: {
				question: 'I found many of these myself.',
				response: {
					0: 'Understood'
				}
			},
		},
		watchAtHome: {
			0: {
				question: "That's the coolest guy I've ever seen.",
			},
		},
		mushroomKingdom: {
			0: {
				question: 'This is a high-traffic destination. Expect crowds.',
				response: {
					0: 'Show me another destination.'
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you.',
				response: {
					0: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					1: { id:'fossilFalls', label: planetNames.fossilFalls },
					2: { id:'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		honeyhiveGalaxy: {
			0: {
				question: 'High pollen levels in this galaxy may affect sensitive travelers.',
				response: {
					0: 'Show me another destination.'
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you.',
				response: {
					0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id:'fossilFalls', label: planetNames.fossilFalls },
					2: { id:'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		fossilFalls: {
			0: {
				question: 'Large wildlife has been observed in this region. Maintain distance.',
				response: {
					0: 'Show me another destination.'
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you.',
				response: {
					0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id:'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		cometObservatory: {
			0: {
				question: 'Special permission required for visitation.',
				response: {
					0: 'Show me another destination.'
				}
			},
			1: {
				question: 'Of course. Choose your destination and I will guide you.',
				response: {
					0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id:'fossilFalls', label: planetNames.fossilFalls },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				}
			}
		},
		dripDropGalaxy: (getDateNum() != '4') && {
			0: {
				question: 'For your safety, this area will remain closed until further notice.',
			},
		},
		tostarenaTown: (getDateNum() === '4')
			? {
				0: {
					question: 'Sun protection is recommended at all times.',
					response: {
						0: 'Show me another destination.'
					}
				},
				1: {
					question: 'Of course. Choose your destination and I will guide you.',
					response: {
						0: { id:'mushroomKingdom', label: planetNames.mushroomKingdom },
						1: { id:'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
						2: { id:'fossilFalls', label: planetNames.fossilFalls },
						3: { id:'cometObservatory', label: planetNames.cometObservatory },
						4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
						5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
					}
				}
			}
			: {
				0: {
					question: 'For your safety, this area will remain closed until further notice.',
				}
			},
		spaceJunkGalaxy: (getDateNum() != '4') && {
			0: {
				question: 'For your safety, this area will remain closed until further notice.',
			},
		},

		glyph: {
			0: {
				question: 'If you see something, say something.'
			},
			1: {
				question: 'Access granted.'
			},
			2: {
				question: 'Please try again.'
			},
			3: {
				question: "Let's not do that again."
			},
		},
		upWorld: {
			// State 0
			0: {
				question: 'That looks... interesting.',
				response: {
					0: 'Take me back.'
				}
			},
			// State 1
			1: {
				question: 'Surface illumination levels have increased.',
				response: {
					0: 'Take me back.'
				}
			},
			// State 3
			2: {
				question: 'Additional structural detail is now visible.',
				response: {
					0: 'Take me back.'
				}
			},
			//State 4
			3: {
				question: 'Destination parameters are resolving.',
				response: {
					0: 'Take me back.',
				}
			},
			//State 5 - April 1st
			4: {
				question: 'Destination: confirmed. Travel at your own risk to Planet Bowser.',
				response: {
					// 0: 'Book now',
					1: 'Watch at home'
				}
			},
		},
		downWorld: {
			0: {
				question: 'This route was not intended.'
			},
			1: {
				question: 'Proceed with caution',
				response: {
					0: "Let's go back."
				}
			}
		},
		boomerang: {
			0: {
				question: 'Object incoming... please... duck'
			}
		},
		inputPlaceholder: 'Enter code'
	},
	// ALT TEXT
	$altWeatherIcon: 'Weather icon indicating environmental conditions within the Gateway Galaxy.',
	$altLogoBoomerang: 'Airline logo for Boomerang Bros. International Airlines featuring a bold boomerang-shaped aircraft icon inspired by the Boomerang Bros\' weapon of choice.',
	$altLogoGalaxyAir: 'Galaxy Air airline logo featuring a bright shooting star icon, representing intergalactic travel and high-speed routes.',
	$altLogoSunshineAir: 'Sunshine Airline logo featuring a Shine Sprite emblem in tribute to Isle Delfino\'s iconic power source.',
	$altConstructionIcon: 'Under construction icon indicating destinations or features not yet available in the Gateway Galaxy.',
	$altRob: 'R.O.B., the Robotic Operating Buddy, serves as a guide within the Gateway Galaxy travel system.',
	$legalsPrompt: 'Legal and Privacy Information',
	$legalsPromptMobile: 'Privacy',
	$legals : {
		adChoices:'Ad choices',
		privacyPolicy:'Privacy policy',
		kidsHelp: "Kid’s help",
		yourPrivacyPolicyChoices:'Your privacy choices',
		caNotice:'CA notice',
		termsOfService:'Terms of service',
		powster:'Platform © 2026 powster',
		nbcUniversal:'© 2026 NBCUniversal media, LLC',
		links : {
			adChoices:'https://www.nbcuniversal.com/privacy/cookies#accordionheader2',
			kidsHelp: 'https://www.nbcuniversalprivacy.com/privacy/children',
			privacyPolicy:'https://www.nbcuniversal.com/privacy',
			caNotice:'https://www.nbcuniversal.com/privacy/california-consumer-privacy-act',
			termsOfService:'https://www.nbcuniversal.com/terms',
			powster:'https://www.powster.com/',
		}
	}
};
